import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Line } from '../../../context/context';

interface LineContextMenuProps {
    contextMenu: { x: number, y: number, line: Line } | null;
    onClose: () => void;
    onEditStyle: (line: Line) => void;
    onDelete: (line: Line) => void;
}

export default function LineContextMenu({
    contextMenu,
    onClose,
    onEditStyle,
    onDelete
}: LineContextMenuProps) {
    const { t } = useTranslation('map');
    if (!contextMenu) return null;

    return (
        <Menu
            open={Boolean(contextMenu)}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={
                contextMenu
                    ? { top: contextMenu.y, left: contextMenu.x }
                    : undefined
            }
            PaperProps={{
                sx: {
                    boxShadow: 3,
                    minWidth: 120,
                }
            }}
        >
            <MenuItem
                onClick={() => {
                    onEditStyle(contextMenu.line);
                    onClose();
                }}
            >
                {t('contextMenu.editStyle')}
            </MenuItem>
            <MenuItem
                onClick={() => {
                    onDelete(contextMenu.line);
                    onClose();
                }}
            >
                {t('contextMenu.delete')}
            </MenuItem>
        </Menu>
    );
} 